import { defaultFill } from '../../utils/constants';
var muiTwitter24 = {
    paths: [
        {
            path: 'M7.54752,19.5014103 C16.60416,19.5014103 21.55776,11.9980503 21.55776,5.49117027 C21.55776,5.27805027 21.55776,5.06589027 21.54336,4.85469027 C22.5070381,4.15764469 23.3389013,3.29457449 24,2.30589027 C23.1013239,2.70409997 22.1479961,2.96524577 21.17184,3.08061027 C22.1997542,2.46523304 22.9690786,1.49735138 23.33664,0.35709027 C22.3700712,0.930647373 21.3126203,1.33486181 20.20992,1.55229027 C18.6835995,-0.0706912222 16.2582906,-0.467921649 14.2939673,0.583343001 C12.329644,1.63460765 11.314824,3.87292297 11.81856,6.04317027 C7.85941991,5.84468983 4.17069675,3.97468061 1.6704,0.89853027 C0.363477846,3.14842921 1.03102837,6.02671537 3.19488,7.47165027 C2.41127155,7.44842552 1.6447482,7.23703892 0.96,6.85533027 L0.96,6.91773027 C0.960641408,9.26165952 2.61288143,11.280484 4.9104,11.7446103 C4.18547481,11.9423127 3.42487736,11.9712128 2.68704,11.8290903 C3.33211001,13.8349362 5.18071158,15.2090428 7.28736,15.2486103 C5.54374564,16.6189449 3.38981713,17.3628449 1.17216,17.3606103 C0.780387426,17.3598582 0.388995903,17.3361375 0,17.2895703 C2.25181051,18.7346358 4.87191687,19.5011385 7.54752,19.4975703',
            fill: defaultFill,
        },
    ],
    title: 'Twitter',
    width: 24,
    height: 20,
};
var muiTwitter = {
    base: muiTwitter24,
    lgIcon: muiTwitter24,
};
export { muiTwitter };
//# sourceMappingURL=twitter.js.map